import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import React from "react";
import PaymentMethod from "./PaymentMethod";

interface CreditCard {
  addressCity?: string | null;
  addressCountry?: string | null;
  addressLineOne?: string | null;
  addressLineTwo?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
  brand?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
  isDefault?: boolean | null;
  last4?: string | null;
  name?: string | null;
}

interface PayPalInfo {
  email?: string | null;
}

interface BillingInformationProps {
  creditCards?: CreditCard[] | null;
  paypal?: PayPalInfo | null;
}

const BillingInformation: React.FC<BillingInformationProps> = ({ creditCards, paypal }) => {
  const renderPayments = () => {
    if (creditCards && creditCards.length > 0) {
      return creditCards.map((creditCard, index) => {
        return <PaymentMethod key={`${index}_${creditCard.last4}`} creditCard={creditCard} />;
      });
    } else {
      return renderPaypal(paypal);
    }
  };

  const renderPaypal = (paypalInfo: PayPalInfo | null | undefined) => (
    <div className="cc">
      <div className="cc-details">
        <img className="cc-img" src="https://static.bigbrain.gg/assets/ugg/icons/light-payment/5.png" alt="PayPal" />
        <div className="cc-info">
          <div className="cc-name">Email</div>
          <div className="cc-exp">{paypalInfo?.email}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="settings-section">
      <div className="section-content billing-info">
        <HeaderBullet className="mb-[24px]">Billing Information</HeaderBullet>
        {renderPayments()}
      </div>
    </div>
  );
};

export default BillingInformation;
